import { paperStyles } from '@festina-life/ui/libs'
import cx from 'classnames'
import type { ReactNode } from 'react'

export const MarkdownCode = ({ children }: { children?: ReactNode }) => (
  <code
    className={cx(
      'font-code wrap-break-word text-wrap text-base! rounded-md p-1 inline-block',
      paperStyles({ isFaded: true, borders: ['all'] }),
    )}
  >
    {children}
  </code>
)
